import { Component } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { FuseProgressBarService } from "@fuse/components/progress-bar/progress-bar.service";
import { Environment } from "app/decorators/environment.decorator";
import { SnackBarService } from "app/services/snackbar.service";
import { Observable } from "rxjs";
import { CheckinService } from "./checkin.service";
import { PageOptions } from "../interface/pageOptions";

export interface Historico {}

@Component({
    selector: "checkin",
    templateUrl: "./checkin.component.html",
    styleUrls: ["./checkin.component.scss"],
})
export class CheckinComponent {
    @Environment("showProfessional") showProfessional: any;
    unitControl = new FormControl("", Validators.required);
    specialityControl = new FormControl("", Validators.required);
    insuranceControl = new FormControl("", Validators.required);
    professionalControl = new FormControl("", Validators.required);
    procedureControl = new FormControl("", Validators.required);
    dateControl = new FormControl("", Validators.required);
    hourControl = new FormControl("", Validators.required);
    selectFormControl = new FormControl("", Validators.required);
    schedulePageOptions: PageOptions;
    displayedColumns: string[] = [
        "dataAgenda",
        "nomeUnidade",
        "grupoProcedimento",
        "checkin",
    ];
    dataSource = [];
    unitList = [];
    specialityList = [];
    insuranceList = [];
    professionalList = [];
    procedureList = [];
    hourList = [];
    filteredSpeciality: Observable<string[]>;
    filteredInsurance: Observable<string[]>;
    filteredProfessional: Observable<string[]>;
    filteredProcedure: Observable<string[]>;
    newCheckin: boolean = false;
    paciente: any;
    unity: any;
    unityValue: any;
    checkinList: any;
    checkin: any;
    currentDate: any;

    constructor(
        private readonly checkinService: CheckinService,
        private progressBar: FuseProgressBarService,
        private snackBar: SnackBarService,
        private router: Router
    ) {
        this.schedulePageOptions = new PageOptions(); 
    }

    async ngOnInit() {
        this.paciente = JSON.parse(localStorage.getItem("paciente"));
        if (!this.paciente) {
            this.router.navigate(["auth/login"]);
        } else {
            this.getCurrentDate();
            await this.getList();
        }
    }

    async getList() {
        this.getScheduleList();
    }

    getScheduleList() {
       
        this.schedulePageOptions.sizePage = 500;
        this.schedulePageOptions.page = 0;
        this.checkinService.getScheduleList(this.paciente.idPaciente, "C", this.schedulePageOptions).then(res =>{            
            this.dataSource = res.body.content;
        })       
    }

    getCurrentDate() {
        var d = new Date(),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        this.currentDate = [year, month, day].join("-");
    }

    checkIn(schedule) {

        this.router.navigate(["/resumo-agenda"], {
            state: {
                schedule: {
                    paciente: {
                        nomePaciente: schedule.personName ? schedule.personName : schedule.patientPersonName,
                        telefone: schedule.personPhoneStandart ? schedule.personPhoneStandart : schedule.patientPersonPhoneStandart,
                        celular: schedule.personPhoneStandart ? schedule.personPhoneStandart : schedule.patientPersonPhoneStandart,
                    },
                    dataAgenda: schedule.date,
                    horaAgenda: schedule.hour,
                    idConvenio: schedule.insuranceId,
                    idAgenda: schedule.id,
                    idProfissional:
                        schedule.performerId,
                    nomeProcedimento: schedule.procedureName,
                    nomeConvenio: schedule.insuranceName,
                    situacaoAgenda: schedule.patientStatus
                    // nomeEspecialidade: this.professional.nomeEspecialidade
                },
            },
        });
        this.progressBar.hide();
    }
}
